import 'slick-carousel';

$('#product .product__slider').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: false,
	arrows: false,
	infinite: false,
	adaptiveHeight: true
});

$('#product .product__thumbs').slick({
	swipeToSlide: true,
	variableWidth: true,
	dots: false,
	arrows: false,
	infinite: false
});

$('#product .product__thumbs').on('click', '.slick-slide', function(event) {
	$('#product .product__slider').slick('slickGoTo', $(this).index());
});
